import { ButtonProps } from '@dtx-company/shared-components/src'
import { FC } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import {
  PrimaryButton,
  SecondaryButton
} from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import Link from 'next/link'

type CTAButtonProps = {
  label?: string
  href?: string
  variant?: string
  iconSrc?: string
  iconAlt?: string
} & ButtonProps

const CTAButton: FC<CTAButtonProps> = ({ label, href, variant, iconSrc, iconAlt, ...rest }) => {
  if (!label) return null
  switch (variant) {
    case 'Primary':
      return (
        <PrimaryButton as="a" href={href} target="_blank" px="16px" {...rest}>
          {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
          {label}
        </PrimaryButton>
      )
    case 'Secondary':
      return (
        <SecondaryButton as="a" href={href} target="_blank" px="16px" {...rest}>
          {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
          {label}
        </SecondaryButton>
      )
    case 'Tertiary':
      return (
        <Link href={href ?? '/'} passHref legacyBehavior>
          <Text
            as="a"
            display="flex"
            variant="button/general"
            alignItems="center"
            color="primary.flowBlue"
            target="_blank"
            cursor="pointer"
            alignSelf="center"
          >
            {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
            {label}
            <Spacer ml="10px" />
          </Text>
        </Link>
      )
    default:
      return null
  }
}

export default CTAButton
